var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageCurigma1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 448.397,
    height: 440.118,
    viewBox: "0 0 448.397 440.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.193,
    x2: 3.193,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-74.853 -28.837)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 63.682,
    cy: 15.921,
    rx: 63.682,
    ry: 15.921,
    transform: "translate(395.885 437.114)",
    fill: "#637dff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M897.847,749.666s-5.763-39.705,11.549-65.838a60.767,60.767,0,0,0,10.273-37.054,101.961,101.961,0,0,0-2.8-18.483",
    transform: "translate(-427.016 -292.397)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M939.048,590.217c-.665,4.669-11.059,17-11.059,17s-6.495-14.755-5.846-19.424a8.54,8.54,0,1,1,16.906,2.426Z",
    transform: "translate(-438.345 -270.872)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M956.437,637.282c-3.1,3.553-18.527,8.249-18.527,8.249s2.552-15.948,5.648-19.479a8.542,8.542,0,1,1,12.879,11.224Z",
    transform: "translate(-445.462 -290.071)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M942.5,715.585c-4.471,1.507-20.161-2.2-20.161-2.2s10.24-12.462,14.711-13.963a8.54,8.54,0,0,1,5.45,16.163Z",
    transform: "translate(-438.455 -324.269)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M919.193,774.467c-4.152,2.238-20.243,1.21-20.243,1.21s7.985-14.007,12.137-16.245a8.541,8.541,0,1,1,8.106,15.035Z",
    transform: "translate(-427.927 -350.959)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M903.94,649.633c2.882,3.734,18,9.349,18,9.349s-1.606-16.047-4.487-19.8a8.542,8.542,0,1,0-13.517,10.449Z",
    transform: "translate(-429.37 -295.807)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M876.129,716.979c3.849,2.7,19.968,3.525,19.968,3.525s-6.324-14.848-10.2-17.532a8.54,8.54,0,1,0-9.773,14.008Z",
    transform: "translate(-416.011 -325.317)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M860.671,788.126c3.355,3.3,19.088,6.847,19.088,6.847s-3.729-15.69-7.089-18.989a8.54,8.54,0,1,0-12,12.154Z",
    transform: "translate(-409.556 -357.76)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M939.048,590.217c-.665,4.669-11.059,17-11.059,17s-6.495-14.755-5.846-19.424a8.54,8.54,0,1,1,16.906,2.426Z",
    transform: "translate(-438.345 -270.872)",
    fill: "#169ec3",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M956.437,637.282c-3.1,3.553-18.527,8.249-18.527,8.249s2.552-15.948,5.648-19.479a8.542,8.542,0,1,1,12.879,11.224Z",
    transform: "translate(-445.462 -290.071)",
    fill: "#169ec3",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M942.5,715.585c-4.471,1.507-20.161-2.2-20.161-2.2s10.24-12.462,14.711-13.963a8.54,8.54,0,0,1,5.45,16.163Z",
    transform: "translate(-438.455 -324.269)",
    fill: "#169ec3",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M919.193,774.467c-4.152,2.238-20.243,1.21-20.243,1.21s7.985-14.007,12.137-16.245a8.541,8.541,0,1,1,8.106,15.035Z",
    transform: "translate(-427.927 -350.959)",
    fill: "#169ec3",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M903.94,649.633c2.882,3.734,18,9.349,18,9.349s-1.606-16.047-4.487-19.8a8.542,8.542,0,1,0-13.517,10.449Z",
    transform: "translate(-429.37 -295.807)",
    fill: "#169ec3",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M876.129,716.979c3.849,2.7,19.968,3.525,19.968,3.525s-6.324-14.848-10.2-17.532a8.54,8.54,0,1,0-9.773,14.008Z",
    transform: "translate(-416.011 -325.317)",
    fill: "#169ec3",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M860.671,788.126c3.355,3.3,19.088,6.847,19.088,6.847s-3.729-15.69-7.089-18.989a8.54,8.54,0,1,0-12,12.154Z",
    transform: "translate(-409.556 -357.76)",
    fill: "#169ec3",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M873.469,749.581s-21.36-33.964-16.1-64.892a60.767,60.767,0,0,0-5.6-38.028A102,102,0,0,0,841.71,630.9",
    transform: "translate(-402.166 -293.572)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M833.8,590.323c1.276,4.542-3.228,20.023-3.228,20.023s-11.934-10.845-13.2-15.4a8.543,8.543,0,0,1,16.443-4.641Z",
    transform: "translate(-391.068 -272.501)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M871.509,625.134c-1.391,4.5-13.589,15.052-13.589,15.052s-4.125-15.585-2.75-20.095a8.542,8.542,0,1,1,16.322,5.043Z",
    transform: "translate(-408.098 -285.997)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M890.25,700.507c-3.476,3.184-19.33,6.132-19.33,6.132s4.311-15.536,7.787-18.7a8.544,8.544,0,0,1,11.549,12.594Z",
    transform: "translate(-415.312 -318.233)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M893.826,764.124c-2.887,3.729-18.016,9.31-18.016,9.31s1.65-16.042,4.51-19.8a8.54,8.54,0,1,1,13.506,10.449Z",
    transform: "translate(-417.513 -347.248)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M825.809,658.863c4.146,2.249,20.238,1.243,20.238,1.243s-7.963-14.018-12.1-16.262a8.541,8.541,0,0,0-8.139,15.019Z",
    transform: "translate(-392.996 -298.933)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M827.5,731.68c4.63.9,19.688-4.867,19.688-4.867s-11.8-11-16.427-11.9A8.541,8.541,0,1,0,827.5,731.68Z",
    transform: "translate(-392.574 -331.297)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M842.7,803.132c4.4,1.65,20.227-1.479,20.227-1.479s-9.767-12.825-14.177-14.5A8.54,8.54,0,0,0,842.7,803.1Z",
    transform: "translate(-400.32 -363.715)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M285.63,57.83V445.787H564.667V57.83Z",
    transform: "translate(-136.247 -28.993)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 274.142,
    height: 14.788,
    transform: "translate(151.83 32.241)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(151.83 32.241)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 274.142,
    height: 14.788,
    fill: "#63c1ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 274.142,
    height: 366.361,
    transform: "translate(151.83 47.029)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.508,
    cy: 2.508,
    r: 2.508,
    transform: "translate(156.532 37.13)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2.508,
    cy: 2.508,
    r: 2.508,
    transform: "translate(163.329 37.13)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.508,
    cy: 2.508,
    r: 2.508,
    transform: "translate(170.126 37.13)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(200.757 69.615)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 176.281,
    height: 6.902,
    fill: "#63c1ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 23.422,
    height: 6.902,
    transform: "translate(353.617 69.615)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(177.968 108.929)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 221.865,
    height: 79.46,
    fill: "#63c1ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 127.975,
    height: 6.902,
    transform: "translate(240.232 137.889)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 66.394,
    height: 6.902,
    transform: "translate(240.232 152.528)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 23.422,
    height: 6.902,
    transform: "translate(353.617 173.437)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 12.544,
    cy: 12.544,
    r: 12.544,
    transform: "translate(192.189 136.113)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(177.968 210.662)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 221.865,
    height: 79.46,
    fill: "#63c1ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 127.975,
    height: 6.902,
    transform: "translate(240.232 239.621)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 66.394,
    height: 6.902,
    transform: "translate(240.232 254.26)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 23.422,
    height: 6.902,
    transform: "translate(353.617 275.169)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 12.544,
    cy: 12.544,
    r: 12.544,
    transform: "translate(192.189 237.845)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(177.968 312.394)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 221.865,
    height: 79.46,
    fill: "#63c1ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 127.975,
    height: 6.902,
    transform: "translate(240.232 341.354)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 66.394,
    height: 6.902,
    transform: "translate(240.232 355.993)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 23.422,
    height: 6.902,
    transform: "translate(353.617 376.901)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 12.544,
    cy: 12.544,
    r: 12.544,
    transform: "translate(192.189 339.577)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M185.949,345.572c-2.128,9.684-5.967,21.618-5.967,21.618,3.795,4.427,20.348,5.219,20.348,5.219l.027-.033h.258c.115.61.247,1.2.407,1.76q-.044.83-.083,1.683a4.592,4.592,0,0,0-.236,2.068,4.671,4.671,0,0,0,.121.462c-.4,8.766-.676,18.115-.434,23.515a22.629,22.629,0,0,0,.467,4.553,16.392,16.392,0,0,1,.484,3.492c.269,7.9-1.65,21.178-1.65,21.178s.049.182.077.275c-.033.225-.055.357-.055.357a6.264,6.264,0,0,1,.281,1.65c.143,6.665-3.679,21.167-3.679,21.167s-3.091,22.3-2.651,30.8a19.582,19.582,0,0,0,.148,2.029c.946,7.067,2.2,26.8,2.2,26.8a8.874,8.874,0,0,0,.72.929c-.11.44-.242.885-.385,1.325a37.175,37.175,0,0,0-1.842,13.814c.038.55.082,1.149.137,1.754.632,7.281,18.247,2.75,19.407,1.9.4-.291.115-2.931-.429-6.28l18.148,4.482s12.868,1.9,18.989,0,5.906-7.149-2.849-8.013c-6.132-.594-11-6.3-13.4-9.673.929-2.535,7.9-21.777,9.178-33.689a168.643,168.643,0,0,1,4.064-22.833l1.369-17.724,2.431-10.449,2.9-13.814c3.272-10.13,4.273-27.062,4.273-27.062l2.53-16.614a32.164,32.164,0,0,0,.588-5.477,61.406,61.406,0,0,1,7.012,1.875c3.96-3.08-1.65-32.754-1.65-32.754s-2.7-18.742-4.988-35.828a35.013,35.013,0,0,1,10.922.445l33.233.731a16.892,16.892,0,0,0,1.782-2.9h1.424a3.053,3.053,0,0,0,.412-.8l.588.11a49.163,49.163,0,0,1,6.357,1.93s10.482,1.265,8.9-9.728c-1.177-8.194-10.5-5.219-15.167-3.184l-.588.269c-.044-.308-.071-.484-.071-.484l-1.5.275a7.254,7.254,0,0,0-.314-.671s-16.3-.632-29.515-2.612c-9.4-1.408-16.5-6.781-19.836-9.761-2.315-11.752-9.041-15.321-9.041-15.321a20.125,20.125,0,0,1-9.167-3.1,19.374,19.374,0,0,1-2.145-1.485l-.363.209-.044-.038c2.238-2.079,4.559-3.987,6.6-5.587l.918-.709a20.386,20.386,0,0,0,16.652-28.547c-.088-.2-.193-.4-.286-.588A4.575,4.575,0,0,0,266,214.5c.2-2.3-1.386-4.757-.346-6.825a6.645,6.645,0,0,0,.495-.962,2.6,2.6,0,0,0,.077-.968,6.814,6.814,0,0,0-2.75-4.949c-2.359-1.71-4.454-.841-7.034-.99a84.917,84.917,0,0,1-8.87-1.375,30.673,30.673,0,0,0-10.19-.335,13.131,13.131,0,0,0-8.612,5.043c-.836,1.2-1.4,2.568-2.2,3.805-.9,1.43-2.057,2.667-3.085,4-1.732,2.238-3.135,4.922-3,7.749.077,1.6.643,3.14.753,4.74a28.865,28.865,0,0,1-.33,4.454,19.5,19.5,0,0,0,.324,5.681,3.52,3.52,0,0,0,.649,1.617,3.448,3.448,0,0,0,1.43.918,12.777,12.777,0,0,0,1.754.55,25.126,25.126,0,0,1-2.458,4.427l-.891-.924-2.409,3.762-.093-.253c-.116.236-.247.462-.385.687l-.247-.687a14.46,14.46,0,0,1-5.395,5.4c-6.3,3.959-15.1,5.6-15.1,5.6-14.166,2.057-11.549,16.69-11.549,16.69s-6.011,26.111-7.7,42.251,4.586,26.424,4.586,26.424Zm67.559-47.723c.55,1.8,1.034,3.5,1.446,4.993l-.264.1c-.3-1.38-.715-3.151-1.166-5.1Zm-15.585-43.813-.077.049.071-.071ZM213.49,526.874c-.693-4.141-1.727-9.14-2.365-12.126.451-1.468,1.05-3.712,1.754-7.05,1.584-7.485,2.53-33.969,2.53-33.969l3.7-22.25a73.39,73.39,0,0,0,4.114-18.7c1.358-3.586,4.5-25.533,5-29.059-.143,2.436-.484,8.606-.665,15.459v.187c-.137,5.175-.176,10.724,0,15.327h0c.05,1.292.115,2.519.2,3.652.027.292.044.594.055.891.4,11.934-4.949,26.947-4.949,26.947s-2.381,11.131-2.029,17.35a11.451,11.451,0,0,0,.473,3.3,5.836,5.836,0,0,1,.269,1.529c.1,5.95-3.415,18.439-4.312,21.5C215.3,513.9,213.847,524.191,213.49,526.874Z",
    transform: "translate(-103.703 -98.648)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M261.9,763.73s6.17,11.186,14.848,12.022,8.887,6.049,2.821,7.946-18.819,0-18.819,0l-18.192-4.493s2.2-17.983,5.12-18.923S261.9,763.73,261.9,763.73Z",
    transform: "translate(-132.509 -351.743)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M224.337,765.944s4.6,20.7,3.454,21.541-18.61,5.329-19.248-1.886c-.055-.6-.1-1.182-.132-1.738a36.647,36.647,0,0,1,1.826-13.693,11.345,11.345,0,0,0,.709-4.224C210.644,763.04,224.337,765.944,224.337,765.944Z",
    transform: "translate(-117.113 -353.77)",
    fill: "#169ec3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M247.79,269.911s14.111,34.646,11.6,23.537c-1.65-7.38,9.079-17.174,16.5-22.932,3.778-2.937,6.7-4.823,6.7-4.823s-26.507-30.9-24.626-17.565a20.073,20.073,0,0,1-1.446,10.757,28.2,28.2,0,0,1-8.733,11.026Z",
    transform: "translate(-134.863 -119.797)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M411.77,369.436a8.112,8.112,0,0,1,3.228.2,47.636,47.636,0,0,1,6.3,1.914s10.394,1.254,8.8-9.64c-1.166-8.128-10.4-5.18-15.03-3.157-1.573.687-2.618,1.27-2.618,1.27Z",
    transform: "translate(-208.664 -170.086)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M411.77,371.26a8.109,8.109,0,0,1,3.228.2c1.127-2.854.27-9.613.088-10.883-1.573.687-2.618,1.27-2.618,1.27Z",
    transform: "translate(-208.664 -171.91)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M410.986,360.721l2.717-.5s1.4,9.349-.423,11.791H410.15Z",
    transform: "translate(-207.935 -171.748)",
    fill: "#cbcdda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M310.7,390.6s8.315-4.949,9.3,1.3,2.3,16.993,2.3,16.993l2.3,13.644,2.981,27.343-.418,4.652s-8.837-2.959-10.927-1.936-3.767-11.472-3.767-11.472l-3.448-12.967-.55-27.5Z",
    transform: "translate(-162.177 -184.584)",
    fill: "#4c4c78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M310.7,390.6s8.315-4.949,9.3,1.3,2.3,16.993,2.3,16.993l2.3,13.644,2.981,27.343-.418,4.652s-8.837-2.959-10.927-1.936-3.767-11.472-3.767-11.472l-3.448-12.967-.55-27.5Z",
    transform: "translate(-162.177 -184.584)",
    fill: "#212121",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M320.65,333.56s8.629,9.723,21.722,11.686,29.251,2.585,29.251,2.585a14.18,14.18,0,0,1-1.8,15.057l-32.936-.726s-7.292-1.584-12.94,0Z",
    transform: "translate(-167.654 -159.749)",
    fill: "#4c4c78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M320.65,333.56s8.629,9.723,21.722,11.686,29.251,2.585,29.251,2.585a14.18,14.18,0,0,1-1.8,15.057l-32.936-.726s-7.292-1.584-12.94,0Z",
    transform: "translate(-167.654 -159.749)",
    fill: "#212121",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M450.84,406.14",
    transform: "translate(-226.248 -192.415)",
    fill: "none",
    stroke: "blue",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M266.192,258.6c3.217,6.88,8.8,11.956,16.916,11.956h1.056c3.778-2.937,6.7-4.823,6.7-4.823s-26.507-30.9-24.626-17.565C266.819,252.221,267.485,255.537,266.192,258.6Z",
    transform: "translate(-143.124 -119.815)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M260.25,237.2a20.161,20.161,0,1,0,5.909-14.3A20.2,20.2,0,0,0,260.25,237.2Z",
    transform: "translate(-140.47 -107.29)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M237.8,393.754s45.062,3.976,46.744-1.776-4.6-21.326-4.6-21.326l2.013-21.75.077-.836s-5.631-23.526-5.444-25.385c.192-1.688-9.09-21.447-11-25.467l-.346-.726-.357.209-.154.093-2.2,1.287-8.727-2.057-10.5-5.5-1,60.163Z",
    transform: "translate(-130.367 -140.379)",
    fill: "#cbcdda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M278.81,302.576a3.591,3.591,0,0,1,4.289,2.249,31.714,31.714,0,0,0,1.65,3.85l1.2,7.149,2.2,11.29,1.617,50.044-.726,8.909-4.026-7.149-.731-46.744v-5.829a42.185,42.185,0,0,0-3.355-14.606l-.55-1.314-3.5-4.493Z",
    transform: "translate(-147.955 -145.758)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M279.941,301.436a3.591,3.591,0,0,1,4.289,2.249,31.719,31.719,0,0,0,1.65,3.85l1.2,7.149,2.2,11.29,1.622,50.044-.737,8.887-4.026-7.149-.731-46.744v-5.829a42.179,42.179,0,0,0-3.349-14.606l-.55-1.314L278,304.785Z",
    transform: "translate(-148.459 -145.245)",
    fill: "#212121",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M254.155,278s10.663,11.3,14.425,12.648c0,0-1.881,8.573-3.762,10.245,0,0-11.191-11.411-13.2-12.335l-1.65-4.064Z",
    transform: "translate(-135.844 -134.744)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M254.155,276.9s10.663,11.3,14.425,12.648c0,0-1.881,8.573-3.762,10.245,0,0-11.191-11.411-13.2-12.335l-1.65-4.064Z",
    transform: "translate(-135.844 -134.249)",
    fill: "#cbcdda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M286.58,301.35l.11.291,3.421,9.162,6.1,17.3s.06.176.165.506c1.012,3.146,6.456,20.221,7.529,25.187l.077-.836s-5.626-23.548-5.439-25.407c.193-1.688-9.09-21.447-11-25.467-.3-.209-.55-.385-.7-.517Z",
    transform: "translate(-152.321 -145.253)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M287.71,301.33l3.531,9.464,6.11,17.3s.06.176.165.506c1.072,3.355,7.182,22.492,7.7,26,.55,3.85,8.249,24.626,8.249,24.626l4.4,35.993c3.921-3.058-1.65-32.446-1.65-32.446s-6.275-43.6-7.76-58.1-9.53-18.791-9.53-18.791a19.965,19.965,0,0,1-9.085-3.074A19.4,19.4,0,0,1,287.71,301.33Z",
    transform: "translate(-152.829 -145.244)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M207.066,605.559c.94,7.006,2.2,26.562,2.2,26.562,4.4,6.6,14.117,3.03,14.117,3.03s1.039-1.991,2.607-9.415,2.513-33.667,2.513-33.667l3.663-22.058a72.734,72.734,0,0,0,4.075-18.505c1.463-3.849,5.021-29.278,5.021-29.278s-1.468,22.795-.55,34.816-4.806,28.234-4.806,28.234-3.245,15.162-1.567,19.864-4.185,24.153-4.185,24.153c.522,5.648,17.147,3.344,17.147,3.344s7.842-21.013,9.2-33.667a167.091,167.091,0,0,1,4.031-22.635l1.353-17.565,2.409-10.35,2.876-13.693c3.239-10.042,4.235-26.82,4.235-26.82l2.508-16.465c1.65-8.145-.478-17.691-1.908-22.707-.616-2.161-1.1-3.487-1.1-3.487-1.441,1.023-9.69,2.2-13.957,3.2a24.286,24.286,0,0,1-7.149.55,158.844,158.844,0,0,1-31.841-5.824l-1.1-.33-.22,1.881-.517,4.487-.913,7.958s-2.827,42.449-1.155,48.2-1.149,25.072-1.149,25.072c1.567,4.586-3.344,23.229-3.344,23.229S206.126,598.558,207.066,605.559Z",
    transform: "translate(-116.461 -217.934)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M207.067,604.419c.94,7.006,2.2,26.562,2.2,26.562,4.4,6.6,14.117,3.03,14.117,3.03s1.039-1.991,2.607-9.415,2.513-33.667,2.513-33.667l3.663-22.058a72.736,72.736,0,0,0,4.075-18.505c1.463-3.85,5.021-29.279,5.021-29.279s-1.468,22.795-.55,34.816-4.806,28.234-4.806,28.234S232.661,599.3,234.338,604s-4.185,24.153-4.185,24.153c.522,5.648,17.147,3.344,17.147,3.344s7.842-21.013,9.2-33.667a167.1,167.1,0,0,1,4.031-22.635l1.353-17.565,2.409-10.35,2.876-13.693c3.239-10.042,4.235-26.82,4.235-26.82l2.508-16.471c1.65-8.139-.478-17.686-1.908-22.7-.616-2.161-1.1-3.487-1.1-3.487-1.441,1.023-9.69,2.2-13.957,3.2a24.278,24.278,0,0,1-7.149.55,158.826,158.826,0,0,1-31.841-5.824l-1.1-.33-.22,1.881-.517,4.487-.913,7.958s-2.827,42.449-1.155,48.2-1.133,25.077-1.133,25.077c1.567,4.586-3.344,23.229-3.344,23.229S206.127,597.418,207.067,604.419Z",
    transform: "translate(-116.461 -217.421)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M260.25,237.177a20.161,20.161,0,0,0,2.678,10.047,10.654,10.654,0,0,0,8.876-2.139c1.611-1.419,2.651-3.36,4.037-5a29.4,29.4,0,0,1,2.887-2.849,8.942,8.942,0,0,1,2.277-1.65,3.091,3.091,0,0,1,2.75-.033c1.1.621,1.5,2,2.123,3.107a4.147,4.147,0,0,0,2.315,2.018,2.453,2.453,0,0,0,2.75-.94c.682-1.177.181-3.014,1.331-3.729a6.923,6.923,0,0,1,.935-.379c1.479-.671,1.65-2.656,1.771-4.273a2.674,2.674,0,0,1,.907-2.128,4.089,4.089,0,0,1,2.343-.192,3.3,3.3,0,0,0,.7-.061,20.2,20.2,0,0,0-38.677,8.189Z",
    transform: "translate(-140.47 -107.267)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M297.929,203.532a6.709,6.709,0,0,1,2.722,4.883,2.569,2.569,0,0,1-.072.962,7.142,7.142,0,0,1-.489.957c-1.034,2.046.55,4.476.341,6.764a4.5,4.5,0,0,1-4.4,3.949,4.3,4.3,0,0,0-2.343.192,2.607,2.607,0,0,0-.907,2.128c-.126,1.622-.291,3.608-1.771,4.273a7.759,7.759,0,0,0-.935.385c-1.149.715-.643,2.557-1.331,3.723a2.447,2.447,0,0,1-2.75.946,4.169,4.169,0,0,1-2.315-2.018c-.632-1.1-1.012-2.486-2.123-3.107a3.107,3.107,0,0,0-2.75.027,8.966,8.966,0,0,0-2.277,1.65,30.045,30.045,0,0,0-2.887,2.849c-1.386,1.65-2.425,3.586-4.042,5-3.036,2.667-7.7,2.931-11.439,1.413a3.5,3.5,0,0,1-1.419-.907,3.553,3.553,0,0,1-.66-1.628,19.546,19.546,0,0,1-.324-5.631,28.416,28.416,0,0,0,.33-4.4c-.1-1.584-.671-3.113-.748-4.7-.138-2.8,1.254-5.461,2.97-7.7,1.023-1.32,2.172-2.546,3.058-3.96.77-1.226,1.331-2.585,2.161-3.773a13.211,13.211,0,0,1,8.535-5,29.87,29.87,0,0,1,10.1.33,83.128,83.128,0,0,0,8.8,1.364C293.513,202.669,295.592,201.805,297.929,203.532Z",
    transform: "translate(-138.257 -99.871)",
    fill: "#472727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M287.71,301.33l3.531,9.464,6.11,17.3s.06.176.165.506h0l-7.7-25.8A19.376,19.376,0,0,1,287.71,301.33Z",
    transform: "translate(-152.829 -145.244)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M218.309,494.515s-.368,11.444,2.717,14.3l8.205-15.475-6.9-3.338Z",
    transform: "translate(-121.588 -230.158)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M183.48,405.643c3.767,4.4,20.15,5.175,20.15,5.175l16.24-25.561s3.85-2.667,11.048-14.667,6.979-21.25,6.6-28.151-4.949-26.743-4.949-26.743c-.7-4.465-10.812-32.446-10.812-32.446A14.336,14.336,0,0,1,216.4,288.6c-6.242,3.91-14.969,5.51-14.969,5.51-14.04,2.04-11.45,16.548-11.45,16.548s-.17,56.407.709,63.149S183.48,405.643,183.48,405.643Z",
    transform: "translate(-105.919 -137.107)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M189.49,484.613l.467,4.179,5.7-2.09,4.179-6.324-3.135-2.458Z",
    transform: "translate(-92.978 -218.061)",
    fill: "#cbcdda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M218.3,468.036l2.981.3,28.751,2.871a46.575,46.575,0,0,0,13.814-.676l13.325-2.667c-.616-2.161-1.1-3.487-1.1-3.487-1.441,1.023-9.69,2.2-13.957,3.2a24.284,24.284,0,0,1-7.149.55,158.84,158.84,0,0,1-31.88-5.824l-1.3,1.551Z",
    transform: "translate(-121.59 -217.691)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(90.388 244.279)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M322.75,466.24a3,3,0,0,0,.28-.16l.027.077Z",
    transform: "translate(-258.987 -463.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M209.5,572.528s4.916-18.643,3.344-23.229c0,0,2.827-19.319,1.149-25.071s1.155-48.2,1.155-48.2l.929-7.958.55-4.487.22-1.881s.374.121,1.1.33l.665.2-.154.737-.522,4.487-.929,7.958s-2.821,42.444-1.155,48.2-1.144,25.071-1.144,25.071c1.567,4.586-3.344,23.229-3.344,23.229s-3.454,24.89-2.513,31.9,2.2,26.556,2.2,26.556c3.206,4.817,9.261,4.213,12.286,3.536-.033.082-.055.126-.055.126s-9.723,3.553-14.117-3.03c0,0-1.254-19.556-2.2-26.562S209.5,572.528,209.5,572.528Z",
    transform: "translate(-206.804 -461.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M253.331,652.091c-1.65-4.7,1.573-19.864,1.573-19.864s5.741-16.206,4.8-28.234c-.39-5.01-.363-11.884-.2-18.2,1.336-8.139,2.607-17.24,2.607-17.24s-1.468,22.789-.522,34.816-4.806,28.233-4.806,28.233-3.245,15.162-1.567,19.864-4.185,24.153-4.185,24.153c.418,4.526,11.164,3.948,15.4,3.536l-.16.434s-16.624,2.3-17.141-3.344C249.152,676.244,255,656.787,253.331,652.091Z",
    transform: "translate(-225.853 -509.79)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M182.34,405.643c3.767,4.4,20.15,5.175,20.15,5.175l16.234-25.561s3.85-2.667,11.054-14.667,6.979-21.25,6.6-28.151-4.949-26.743-4.949-26.743c-.7-4.465-10.812-32.446-10.812-32.446a14.336,14.336,0,0,1-5.351,5.351c-6.247,3.91-14.964,5.51-14.964,5.51-14.04,2.04-11.45,16.548-11.45,16.548s-.154,56.385.709,63.127S182.34,405.643,182.34,405.643Z",
    transform: "translate(-105.406 -137.107)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M244.551,297.114l3.531,1.331-2.354,1.65,17.554,42.345c-.407-6.9-4.949-26.743-4.949-26.743-.7-4.465-10.812-32.446-10.812-32.446a14.336,14.336,0,0,1-5.351,5.351Z",
    transform: "translate(-132.333 -137.107)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M193.735,429.735l-17.961-4.625L173.42,432.4l18.351,4.471Z",
    transform: "translate(-85.746 -194.293)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M202.525,313.026s8.156,7.7,5.1,24.78-8,35.68-8,35.68l13.281,36.78s-9.255,9.646-13.8,10.817l-13.253-29.405s-6.192-10.2-4.548-26.188,7.606-41.878,7.606-41.878S188.881,307.851,202.525,313.026Z",
    transform: "translate(-104.814 -150.038)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M201.373,313.026s8.156,7.7,5.1,24.78-8,35.68-8,35.68l13.237,36.78s-9.239,9.646-13.8,10.817l-13.253-29.4s-6.192-10.2-4.548-26.188,7.606-41.878,7.606-41.878S187.718,307.851,201.373,313.026Z",
    transform: "translate(-104.278 -150.038)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M229.138,492.073s-10.35,14.3-9.563,18.148S223.392,512,223.392,512l4.1-5.6,3.663-10.449S230.788,491.457,229.138,492.073Z",
    transform: "translate(-122.145 -231.064)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M231.464,492.073s-10.355,14.3-9.569,18.148S225.712,512,225.712,512l4.075-5.593,3.663-10.449S233.092,491.457,231.464,492.073Z",
    transform: "translate(-123.189 -231.064)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M230.318,492.073s-10.35,14.3-9.563,18.148S224.572,512,224.572,512l4.075-5.593,3.663-10.449S231.952,491.457,230.318,492.073Z",
    transform: "translate(-122.676 -231.064)",
    fill: "#474463"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCurigma1);
export default __webpack_public_path__ + "static/media/Image-curigma1.b520b1abad0caf470da654f69398aeb0.svg";
export { ForwardRef as ReactComponent };